import { render, staticRenderFns } from "./acceptance_rule_edit.vue?vue&type=template&id=746ae3a6&"
import script from "./acceptance_rule_edit.vue?vue&type=script&lang=js&"
export * from "./acceptance_rule_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports